import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { EyeIcon, EyeOffIcon, MailIcon, LockIcon } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
    console.log({
      email,
      password,
      rememberMe
    });
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-2702">
      <div className="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-2703">
        <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-2704">
          <Link to="/" className="flex justify-center" data-id="element-2705">
            <div className="relative" data-id="element-2706">
              <span className="text-2xl font-bold text-blue-900" data-id="element-2707">
                Elevate<span className="text-yellow-500" data-id="element-2708">IT</span>
              </span>
              <span className="text-sm font-normal ml-0.5 text-blue-600" data-id="element-2709">
                .fr
              </span>
              <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-2710"></div>
            </div>
          </Link>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-2711">
            Connexion à votre compte
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-2712">
            Ou{' '}
            <Link to="/essai-gratuit" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-2713">
              commencez votre essai gratuit de 7 jours
            </Link>
          </p>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-2714">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-2715">
            <form className="space-y-6" onSubmit={handleSubmit} data-id="element-2716">
              <div data-id="element-2717">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-2718">
                  Adresse email
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-2719">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2720">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-2721" />
                  </div>
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" placeholder="exemple@entreprise.com" data-id="element-2722" />
                </div>
              </div>
              <div data-id="element-2723">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-2724">
                  Mot de passe
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-2725">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2726">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-2727" />
                  </div>
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-2728" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-2729">
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-2730">
                      {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-2731" /> : <EyeIcon className="h-5 w-5" data-id="element-2732" />}
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-2733">
                <div className="flex items-center" data-id="element-2734">
                  <input id="remember_me" name="remember_me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2735" />
                  <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-700" data-id="element-2736">
                    Se souvenir de moi
                  </label>
                </div>
                <div className="text-sm" data-id="element-2737">
                  <Link to="/mot-de-passe-oublie" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-2738">
                    Mot de passe oublié?
                  </Link>
                </div>
              </div>
              <div data-id="element-2739">
                <Button variant="secondary" fullWidth type="submit" className="shadow-sm" data-id="element-2740">
                  Se connecter
                </Button>
              </div>
            </form>
            <div className="mt-6" data-id="element-2741">
              <div className="relative" data-id="element-2742">
                <div className="absolute inset-0 flex items-center" data-id="element-2743">
                  <div className="w-full border-t border-gray-300" data-id="element-2744"></div>
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-2745">
                  <span className="px-2 bg-white text-gray-500" data-id="element-2746">
                    Ou continuer avec
                  </span>
                </div>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-2747">
                <div data-id="element-2748">
                  <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2749">
                    <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" data-id="element-2750">
                      <path d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z" fill="#EA4335" data-id="element-2751" />
                      <path d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z" fill="#4285F4" data-id="element-2752" />
                      <path d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z" fill="#FBBC05" data-id="element-2753" />
                      <path d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z" fill="#34A853" data-id="element-2754" />
                    </svg>
                  </button>
                </div>
                <div data-id="element-2755">
                  <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2756">
                    <svg className="h-5 w-5 text-[#1877F2]" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" data-id="element-2757">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-2758" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-gray-50 border-t border-gray-200 py-6" data-id="element-2759">
        <div className="container mx-auto px-4" data-id="element-2760">
          <div className="text-center text-sm text-gray-600" data-id="element-2761">
            <p className="mb-2" data-id="element-2762">© 2025 ElevateIT. Tous droits réservés.</p>
            <div className="flex justify-center space-x-4" data-id="element-2763">
              <Link to="/mentions-legales" className="hover:text-blue-600" data-id="element-2764">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-blue-600" data-id="element-2765">
                Confidentialité
              </Link>
              <Link to="/cgv" className="hover:text-blue-600" data-id="element-2766">
                CGV
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}